// All runtime config is sourced from environment variables (exposed to CRA via
// the REACT_APP_ prefix). Each Amplify branch — and a local .env.local — injects
// its own values, so nothing cross-environment is baked into the bundle.
//
// The API URLs are non-secret and fall back to the dev API so `npm start` works
// with no setup. Secrets (Auth0, Google) have no fallback and must be provided
// per environment; they are still visible in the client bundle, so the Google
// Maps key must be HTTP-referrer + API restricted in Google Cloud Console.
// The dev API fallback keeps `npm start` working with no setup, but ONLY in
// development builds. A production build (NODE_ENV === "production", which Amplify
// uses for every deployed branch) must never silently fall back — sending PHI to
// the dev backend on a misconfigured env var is a security incident, not a default.
export const DEV_API = "https://dev-api-v2.pegasuscybersoft.com";
const isProduction = process.env.NODE_ENV === "production";

export const appConfig: AppConfig = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    (isProduction ? "" : `${DEV_API}/api/v2/`),
  REQUEST_FORM_API_BASE_URL:
    process.env.REACT_APP_REQUEST_FORM_API_BASE_URL ||
    (isProduction ? "" : `${DEV_API}/rf-api/v2/`),
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN || "",
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
};

// REACT_APP_-prefixed names of any required var that resolved empty. The bootstrap
// (index.tsx) consumes this to block startup with a meaningful message in a
// production build — mounting the app with empty Auth0/API config would otherwise
// fail with an opaque runtime error at the auth step. We don't throw here: a throw
// during this module's evaluation can't be caught by any error boundary (it
// happens before React mounts) and would just yield a blank screen.
export const missingEnvVars = (
  [
    "API_BASE_URL",
    "REQUEST_FORM_API_BASE_URL",
    "AUTH0_DOMAIN",
    "AUTH0_CLIENT_ID",
    "GOOGLE_API_KEY",
  ] as const
)
  .filter((key) => !appConfig[key])
  .map((key) => `REACT_APP_${key}`);

if (missingEnvVars.length && !isProduction) {
  // Dev only: warn so local work isn't blocked. Names only — never the values.
  // eslint-disable-next-line no-console
  console.warn(
    `Missing required environment variables: ${missingEnvVars.join(", ")}`
  );
}

const useConfig = (): AppConfig => {
  return appConfig;
};

export default useConfig;
